function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 94"
}, props), React.createElement("path", {
  d: "M35.978 2s1.849 18.786-3.615 28.541c-1.161 2.07-2 4.37-2.102 6.817-.151 3.807 1.136 8.383 8.197 8.383h5.211c7.06 0 8.348-4.569 8.197-8.383-.101-2.44-.94-4.746-2.101-6.817C44.295 20.786 46.149 2 46.149 2M47.424 92c-.48-7.457.057-14.943.624-20.11.373-3.4 1.704-6.531 3.629-9.179.019-.02.031-.05.05-.07 1.256-1.773.713-4.441-1.085-5.466-1.647-.932-4.53-1.764-9.585-1.764-5.054 0-7.937.832-9.584 1.764-1.798 1.018-2.34 3.693-1.085 5.465.019.021.031.05.05.071 1.931 2.648 3.256 5.778 3.635 9.18.568 5.173 1.104 12.659.624 20.109",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M80 56.457l-5.66-6.383-5.578 6.29-5.59-6.304-5.679 6.404-.65-.733c-3.13-3.53-7.376-5.515-11.805-5.515h-7.944c-4.43 0-8.675 1.986-11.805 5.515l-.65.733-5.679-6.404-5.59 6.304-5.616-6.333L2 56.521",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));